import React, { useState } from 'react';
import { ArrowRight, Star } from 'lucide-react';
import '../../App.css'
import { CheckCircle, Trophy, Lightbulb, Heart, Zap, BookOpen, MapPin, Mail, Phone, Send, Calculator, Users, Clock, Target, Award, Gamepad2, Brain } from 'lucide-react';
import mainBg from '../../Assest/bg-main.jpg'
import kiddyImg from '../../Assest/kiddy.jpg'
import BuddyImg from '../../Assest/buddy.jpg'
import HappyLearing from '../../Assest/happyLearing.jpg'
const Home = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    program: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically handle the form submission
    console.log('Form submitted:', formData);
    setIsSubmitted(true);

    // Reset form after 3 seconds
    setTimeout(() => {
      setIsSubmitted(false);
      setFormData({ name: '', email: '', phone: '', message: '', program: '' });
    }, 3000);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }

  };

  const benefits = [
    {
      icon: Trophy,
      title: 'Proven Abacus Methodology',
      description: 'Time-tested techniques that have helped thousands of children worldwide excel in mathematics.',
      color: 'text-yellow-600 bg-yellow-100'
    },
    {
      icon: Zap,
      title: 'Improves Focus, Memory & Logic',
      description: 'Our program enhances concentration, strengthens memory retention, and develops logical thinking.',
      color: 'text-purple-600 bg-purple-100'
    },
    {
      icon: Heart,
      title: 'Boosts Confidence in Math',
      description: 'Children develop a positive relationship with mathematics, eliminating math anxiety forever.',
      color: 'text-red-600 bg-red-100'
    },
    {
      icon: BookOpen,
      title: 'Real-Life Applications',
      description: 'Practical problem-solving skills that extend beyond the classroom into everyday situations.',
      color: 'text-blue-600 bg-blue-100'
    },
    {
      icon: Lightbulb,
      title: 'Creative Problem Solving',
      description: 'Students learn multiple approaches to solve problems, fostering innovative thinking.',
      color: 'text-green-600 bg-green-100'
    },
    {
      icon: CheckCircle,
      title: 'Holistic Development',
      description: 'Beyond math skills, we focus on overall cognitive and personal development of each child.',
      color: 'text-indigo-600 bg-indigo-100'
    }
  ];
  const features = [
    {
      icon: Calculator,
      title: 'Abacus + Modern Techniques',
      description: 'Combining traditional abacus methods with innovative teaching approaches for optimal learning.',
      color: 'text-primary-600 bg-primary-100'
    },
    {
      icon: Gamepad2,
      title: 'Fun, Game-Based Learning',
      description: 'Interactive games and activities that make math enjoyable and engaging for children.',
      color: 'text-secondary-600 bg-secondary-100'
    },
    {
      icon: Users,
      title: 'Personalized Attention',
      description: 'Small class sizes ensure every child receives individual attention and customized learning.',
      color: 'text-accent-600 bg-accent-100'
    },
    {
      icon: Brain,
      title: 'Brain Development Focus',
      description: 'Specially designed curriculum that enhances cognitive abilities and mental calculation skills.',
      color: 'text-purple-600 bg-purple-100'
    }]
  return (
    <>
      <section id="home" className="hero-section">
        <div className="hero-container">
          <div className="hero-grid">
            {/* Content */}
            <div className="hero-content">
              <div className="hero-badge">
                <div className="hero-badge-content">
                  <Star className="h-4 w-4 text-accent-600 fill-current" />
                  <span className="hero-badge-text">Trusted by 100+ Parents</span>
                </div>
              </div>

              <h1 className="hero-title">
                Welcome to{' '}
                <span className="hero-brand">Amigo Math</span>
                <br />
                <span className="hero-tagline">
                  Calculating Success Together
                </span>
              </h1>

              <p className="hero-description">
                Where learning math becomes an exciting journey. At Amigo Math, we believe every child has the potential to excel in mathematics when given the right tools.
              </p>

              <p className="hero-subtitle">
                Our unique blend of abacus techniques and modern methods builds confidence, concentration, and problem-solving skills in children aged 5-15.
              </p>

              <div className="hero-buttons">
                <button
                  onClick={scrollToContact}
                  className="hero-primary-button"
                >
                  Join Now
                  <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
                </button>
                <button
                  onClick={scrollToContact}
                  className="hero-secondary-button"
                >
                  Book Free Demo
                </button>
              </div>
            </div>

            {/* Image */}
            <div className="hero-image-container">
              <div className="hero-image-wrapper">
                <img src={mainBg} />
              </div>

              {/* Decorative elements */}
              <div className="hero-decoration-1"></div>
              <div className="hero-decoration-2"></div>

              {/* Floating stats card */}
              <div className="hero-stats-card">
                <div className="text-center">
                  <div className="hero-stats-number">95%</div>
                  <div className="hero-stats-label">Improvement Rate</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="features-section" id='whyUs'>
        <div className="features-container">
          <div className="features-header">
            <h2 className="features-title">
              Why Choose Amigo Math?
            </h2>
            <p className="features-description">
              Our unique approach combines proven methodologies with modern teaching techniques to create an exceptional learning experience.
            </p>
          </div>

          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className={`feature-icon ${feature.color}`}>
                  <feature.icon className="h-8 w-8" />
                </div>
                <div>
                  <h3 className="feature-title">
                    {feature.title}
                  </h3>
                  <p className="feature-description">
                    {feature.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>


        <section id="courses" className="courses-section">
          <div className="courses-container">
            <div className="courses-header">
              <h2 className="courses-title">
                Innovative Math Programs for Every Age
              </h2>
              <p className="courses-description">
                Our carefully structured programs are designed to meet children at their developmental stage and guide them to mathematical excellence.
              </p>
            </div>

            <div className="courses-grid">
              {/* KIDDY Program */}
              <div className="course-card kiddy">
                <div className="course-badge kiddy">
                  <h3 className="course-badge-text">KIDDY (Ages 5-8)</h3>
                </div>

                <div className="course-image-container">
                  {/* <img
                    src="https://images.pexels.com/photos/8613066/pexels-photo-8613066.jpeg?auto=compress&cs=tinysrgb&w=600"
                    alt="Young children learning with abacus"
                    className="course-image"
                  /> */}

                  <img src={kiddyImg} />
                </div>

                <div className="course-features">
                  <div className="course-feature">
                    <Target className="course-feature-icon kiddy" />
                    <span className="course-feature-text">Introduction to addition and subtraction fundamentals</span>
                  </div>
                  <div className="course-feature">
                    <Target className="course-feature-icon kiddy" />
                    <span className="course-feature-text">Hands-on abacus learning and basic mental arithmetic</span>
                  </div>
                  <div className="course-feature">
                    <Target className="course-feature-icon kiddy" />
                    <span className="course-feature-text">Memory-boosting activities and cognitive development</span>
                  </div>
                  <div className="course-feature">
                    <Target className="course-feature-icon kiddy" />
                    <span className="course-feature-text">Fun games and interactive learning sessions</span>
                  </div>
                </div>

                <div className="course-info">
                  {/* <div className="course-info-item">
                    <Clock className="h-4 w-4" />
                    <span>1 hour sessions</span>
                  </div>
                  <div className="course-info-item">
                    <Users className="h-4 w-4" />
                    <span>Max 6 students</span>
                  </div> */}
                </div>

                <button
                  onClick={scrollToContact}
                  className="course-button kiddy"
                >
                  Enroll in KIDDY Program
                </button>
              </div>

              {/* BUDDY Program */}
              <div className="course-card buddy">
                <div className="course-badge buddy">
                  <h3 className="course-badge-text">BUDDY (Ages 9-15)</h3>
                </div>

                <div className="course-image-container">
                  {/* <img
                    src="https://images.pexels.com/photos/8613272/pexels-photo-8613272.jpeg?auto=compress&cs=tinysrgb&w=600"
                    alt="Older children working on advanced math problems"
                    className="course-image"
                  /> */}

                  <img src={BuddyImg} />
                </div>

                <div className="course-features">
                  <div className="course-feature">
                    <Award className="course-feature-icon buddy" />
                    <span className="course-feature-text">Advanced abacus techniques and complex calculations</span>
                  </div>
                  <div className="course-feature">
                    <Award className="course-feature-icon buddy" />
                    <span className="course-feature-text">Mathematical tricks and problem-solving strategies</span>
                  </div>
                  <div className="course-feature">
                    <Award className="course-feature-icon buddy" />
                    <span className="course-feature-text">Competitive exam preparation (Math Olympiads)</span>
                  </div>
                  <div className="course-feature">
                    <Award className="course-feature-icon buddy" />
                    <span className="course-feature-text">Advanced mental math and speed calculation</span>
                  </div>
                </div>

                <div className="course-info">
                  {/* <div className="course-info-item">
                    <Clock className="h-4 w-4" />
                    <span>1.5 hour sessions</span>
                  </div>
                  <div className="course-info-item">
                    <Users className="h-4 w-4" />
                    <span>Max 8 students</span>
                  </div> */}
                </div>

                <button
                  onClick={scrollToContact}
                  className="course-button buddy"
                >
                  Enroll in BUDDY Program
                </button>
              </div>
            </div>

            {/* Why Choose Us Section */}
            <div className="courses-why-choose">
              <h3 className="courses-why-title">Why Choose Our Programs?</h3>
              <div className="courses-why-grid">
                <div className="courses-why-item">
                  <div className="courses-why-icon bg-primary-100">
                    <Gamepad2 className="h-8 w-8 text-primary-600" />
                  </div>
                  <h4 className="courses-why-item-title">Game-based Learning</h4>
                  <p className="courses-why-item-description">Interactive methods that make learning fun</p>
                </div>
                <div className="courses-why-item">
                  <div className="courses-why-icon bg-secondary-100">
                    <Brain className="h-8 w-8 text-secondary-600" />
                  </div>
                  <h4 className="courses-why-item-title">Cognitive Development</h4>
                  <p className="courses-why-item-description">Focus on brain development and thinking skills</p>
                </div>
                <div className="courses-why-item">
                  <div className="courses-why-icon bg-accent-100">
                    <Target className="h-8 w-8 text-accent-600" />
                  </div>
                  <h4 className="courses-why-item-title">Structured Curriculum</h4>
                  <p className="courses-why-item-description">Age-appropriate, research-backed programs</p>
                </div>
                <div className="courses-why-item">
                  <div className="courses-why-icon bg-purple-100">
                    <Users className="h-8 w-8 text-purple-600" />
                  </div>
                  <h4 className="courses-why-item-title">Expert Educators</h4>
                  <p className="courses-why-item-description">Qualified mentors and experienced teachers</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="why-us" className="why-us-section">
          <div className="why-us-container">
            <div className="why-us-header">
              <h2 className="why-us-title">
                The Amigo Math Advantage
              </h2>
              <p className="why-us-description">
                Discover why parents and children love our unique approach to mathematics education.
              </p>
            </div>

            <div className="benefits-grid">
              {benefits.map((benefit, index) => (
                <div key={index} className="benefit-card">
                  <div className={`benefit-icon ${benefit.color}`}>
                    <benefit.icon className="h-7 w-7" />
                  </div>
                  <div>
                    <h3 className="benefit-title">
                      {benefit.title}
                    </h3>
                    <p className="benefit-description">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* Success Stories Section */}
            <div className="success-stories">
              <div className="success-content">
                <h3 className="success-title">
                  Happy Learning Environment
                </h3>
                <p className="success-description">
                  Our students don't just learn mathematics – they fall in love with it. Through our engaging methodology, children develop confidence, critical thinking skills, and a genuine enthusiasm for problem-solving.
                </p>
                <div className="success-stats">
                  <div className="success-stat">
                    <CheckCircle className="success-stat-icon" />
                    <span className="success-stat-text">95% improvement in math scores within 6 months</span>
                  </div>
                  <div className="success-stat">
                    <CheckCircle className="success-stat-icon" />
                    <span className="success-stat-text">85% of students report increased confidence</span>
                  </div>
                  <div className="success-stat">
                    <CheckCircle className="success-stat-icon" />
                    <span className="success-stat-text">100% parent satisfaction rate</span>
                  </div>
                </div>
              </div>

              <div className="success-image-container">
                {/* <img
              src="https://images.pexels.com/photos/8613320/pexels-photo-8613320.jpeg?auto=compress&cs=tinysrgb&w=600"
              alt="Happy children learning together"
              className="success-image"
            /> */}
                <img src={HappyLearing} />
                <div className="success-badge">
                  <div className="text-center">
                    <div className="success-badge-number">100+</div>
                    <div className="success-badge-label">Happy Students</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

      </section>

      <section id="contact" className="contact-section">
        <div className="contact-container">
          <div className="contact-header">
            <h2 className="contact-title">
              Let's Talk Math!
            </h2>
            <p className="contact-description">
              Ready to start your child's mathematical journey? Get in touch with us today for a free consultation and demo class.
            </p>
          </div>

          <div className="contact-grid">
            {/* Contact Information */}
            <div className="contact-info">
              <div>
                <h3 className="contact-info-title">Get in Touch</h3>
                <div className="contact-info-list">
                  <div className="contact-info-item">
                    <div className="contact-info-icon bg-primary-100">
                      <MapPin className="h-6 w-6 text-primary-600" />
                    </div>
                    <div className="contact-info-content">
                      <h4>Visit Us</h4>
                      <p>
                        NO21, Sri Lakshmi Narayani Nagar<br />
                        Sripuram, Vellore 632055
                      </p>
                    </div>
                  </div>

                  <div className="contact-info-item">
                    <div className="contact-info-icon bg-secondary-100">
                      <Phone className="h-6 w-6 text-secondary-600" />
                    </div>
                    <div className="contact-info-content">
                      <h4>Call Us</h4>
                      <p>+91 9940815691</p>
                    </div>
                  </div>

                  <div className="contact-info-item">
                    <div className="contact-info-icon bg-accent-100">
                      <Mail className="h-6 w-6 text-accent-600" />
                    </div>
                    <div className="contact-info-content">
                      <h4>Email Us</h4>
                      <p>amigoomath@gmail.com</p>
                    </div>
                  </div>

                  <div className="contact-info-item">
                    <div className="contact-info-icon bg-purple-100">
                      <Clock className="h-6 w-6 text-purple-600" />
                    </div>
                    <div className="contact-info-content">
                      <h4>Operating Hours</h4>
                      <p>
                        Monday - Saturday: 9:00 AM - 7:00 PM<br />
                        Sunday: 10:00 AM - 5:00 PM
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="contact-offer">
                <h4 className="contact-offer-title">🎉 Special Offer!</h4>
                <p className="contact-offer-text">
                  Book a free trial class today and get 20% off your first month enrollment!
                </p>
                <button className="contact-offer-button">
                  Book Free Trial
                </button>
              </div>
            </div>

            {/* Contact Form */}
            <div className="contact-form" >
              {isSubmitted ? (
                <div className="success-message">
                  <CheckCircle className="success-icon" />
                  <h3 className="success-title">Thank You!</h3>
                  <p className="success-text">
                    We've received your message and will get back to you within 24 hours.
                  </p>
                </div>
              ) : (
                <>
                  <h3 className="contact-form-title">Send us a Message</h3>
                  <form className="form-group">
                    <div className="form-field">
                      <label htmlFor="name" className="form-label">
                        Parent/Guardian Name *
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        required
                        value={formData.name}
                        //   onChange={handleChange}
                        className="form-input"
                        placeholder="Enter your full name"
                      />
                    </div>

                    <div className="form-field">
                      <label htmlFor="email" className="form-label">
                        Email Address *
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        required
                        value={formData.email}
                        //   onChange={handleChange}
                        className="form-input"
                        placeholder="Enter your email"
                      />
                    </div>

                    <div className="form-field">
                      <label htmlFor="phone" className="form-label">
                        Phone Number *
                      </label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        required
                        value={formData.phone}
                        //   onChange={handleChange}
                        className="form-input"
                        placeholder="Enter your phone number"
                      />
                    </div>

                    <div className="form-field">
                      <label htmlFor="program" className="form-label">
                        Program Interest
                      </label>
                      <select
                        id="program"
                        name="program"
                        value={formData.program}
                        //   onChange={handleChange}
                        className="form-select"
                      >
                        <option value="">Select a program</option>
                        <option value="kiddy">KIDDY (Ages 5-8)</option>
                        <option value="buddy">BUDDY (Ages 9-15)</option>
                        <option value="both">Both Programs</option>
                      </select>
                    </div>

                    <div className="form-field">
                      <label htmlFor="message" className="form-label">
                        Message
                      </label>
                      <textarea
                        id="message"
                        name="message"
                        rows={4}
                        value={formData.message}
                        //   onChange={handleChange}
                        className="form-textarea"
                        placeholder="Tell us about your child's age, current math level, or any questions you have..."
                      />
                    </div>

                    <button
                      type="submit"
                      className="form-submit"
                    >
                      <Send className="h-5 w-5" />
                      <span>Send Message</span>
                    </button>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;